var render = function render(_c,_vm){return _c('div',{staticClass:"Subheading",class:[_vm.data.class, _vm.data.staticClass]},[_c('h2',[_vm._t("default",function(){return [_vm._v("[Subheading]")]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }